type CheckInCelebrationPayload = {
  workoutId: number
}

export const postCheckInCelebration = ({
  workoutId,
}: CheckInCelebrationPayload): boolean => {
  if (!window.ReactNativeWebView?.postMessage) return false

  window.ReactNativeWebView.postMessage(
    JSON.stringify({
      type: 'CHECK_IN_CELEBRATION',
      payload: { workoutId },
    }),
  )

  return true
}

export const postLiveCheckInCompleted = ({
  workoutId,
}: CheckInCelebrationPayload): boolean => {
  if (!window.ReactNativeWebView?.postMessage) return false

  window.ReactNativeWebView.postMessage(
    JSON.stringify({
      type: 'LIVE_CHECK_IN_COMPLETED',
      payload: { workoutId },
    }),
  )

  return true
}
